import { Component, Input, OnInit } from "@angular/core";
import { LayoutStoreService } from "@shared/layout/layout-store.service";

@Component({
  selector: "app-mainheader",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  sidebarExpanded: boolean;
  sidebarAberta = false;

  constructor(private _layoutStore: LayoutStoreService) {}

  ngOnInit(): void {
    this._layoutStore.sidebarExpanded.subscribe((value) => {
      this.sidebarExpanded = value;
    });
  }

  toggleSidebar() {
    this._layoutStore.setSidebarExpanded(!this.sidebarExpanded);

    this.sidebarAberta = !this.sidebarAberta;
    this.sidebarExpanded = this.sidebarExpanded;

    const menuIcon = document.querySelector(".menu-icon");
    if (this.sidebarAberta) {
      menuIcon?.classList.add("open");
    } else {
      menuIcon?.classList.remove("open");
    }

    const menuText = document.querySelector(".menu-text");

    if (this.sidebarAberta) {
      menuIcon?.classList.add("open");
      menuText?.classList.add("open");
    } else {
      menuIcon?.classList.remove("open");
      menuText?.classList.remove("open");
    }
  }
}
